import { Routes, Route, Navigate } from "react-router-dom";
import { NavigationHeader } from "./components/NavigationHeader";
import { SiteFooter } from "./components/SiteFooter";
import Home from "./pages/Home";
import CompanyPurpose from "./pages/CompanyPurpose";
import CompanyLeadership from "./pages/CompanyLeadership";
import CompanyCareers from "./pages/CompanyCareers";
import Contact from "./pages/Contact";
import RequestDemo from "./pages/RequestDemo";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import DealerCodeOfConduct from "./pages/DealerCodeOfConduct";
import NotFound from "./pages/NotFound";

function App() {
  return (
    <div className="flex min-h-screen flex-col font-sans" style={{ background: "#F7F7F5" }}>
      <a
        href="#main-content"
        className="sr-only rounded-md bg-[#1F2A3A] px-4 py-2 text-sm font-semibold text-white focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50"
      >
        Skip to main content
      </a>
      <NavigationHeader />
      <div id="main-content" tabIndex={1} className="outline-none flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/company" element={<Navigate to="/company/purpose" replace />} />
          <Route path="/company/purpose" element={<CompanyPurpose />} />
          <Route path="/company/leadership" element={<CompanyLeadership />} />
          <Route path="/company/careers" element={<CompanyCareers />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/request-demo" element={<RequestDemo />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/dealer-code-of-conduct" element={<DealerCodeOfConduct />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <SiteFooter />
    </div>
  );
}

export default App;
